import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, Injectable } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

// Componentes
import { LogoconsotaComponent } from './shared/logoconsota/logoconsota.component';

import * as Sentry from '@sentry/browser';
import { MenuprincipalComponent } from './menuprincipal/menuprincipal.component';

import { AuthInterceptor } from './core/services/auth.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// environment.production

Sentry.init({
  dsn: 'https://cb9591aaf8644e6c99dadb0da6cfddfd@sentry.io/1805230'
});

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() {}
  handleError(error) {
    const eventId = Sentry.captureException(error.originalError || error);
    Sentry.showReportDialog({ eventId });
  }
}

@NgModule({
  declarations: [
    AppComponent,
    LogoconsotaComponent,
    MenuprincipalComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    SweetAlert2Module,
    BrowserAnimationsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }
